var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlackOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 2.25,
    r: 2.25,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74988 0.75H5.99982H1.38525C1.11007 0.75 0.884277 0.97579 0.884277 1.25097C0.884255 1.37001 0.9268 1.48513 1.00423 1.57554L4.65214 5.83026C4.95555 6.18306 5.11783 6.62758 5.11783 7.09327V11.0728C5.11783 11.1575 5.17428 11.1998 5.2025 11.221C5.23073 11.2422 5.29423 11.2704 5.37184 11.228L6.78303 10.5225C6.84653 10.4942 6.88181 10.4378 6.88181 10.3672V7.09327C6.88181 6.62758 7.0441 6.18306 7.3475 5.83026L8.02092 5.04483",
    stroke: "#020817",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlackOpen);
export default __webpack_public_path__ + "static/media/filter_black_open.7067dd3951349cf955565bfa2082fd42.svg";
export { ForwardRef as ReactComponent };